import { mount } from './main';

const container = document.getElementById('app');
if (!container) {
  throw new Error('No #app element to mount into');
}
mount(container);
